import React, { useState } from 'react';
import { AZUL, LARANJA, VERDE, CINZA } from '../styles/colors';
import { cadastrarCliente } from '../firebase';

const ETAPAS = ['Conta', 'Empresa', 'Endereço'];

function Cadastro({ onNavegar, onLogin, vendedorLink }) {
  const [etapa,     setEtapa]     = useState(0);
  const [concluido, setConcluido] = useState(false);
  const [salvando,  setSalvando]  = useState(false);
  const [erroGeral, setErroGeral] = useState('');
  const [form, setForm] = useState({
    nome: '', email: '', telefone: '', senha: '', confirmarSenha: '',
    cnpj: '', razaoSocial: '',
    cep: '', endereco: '', numero: '', cidade: '', estado: '',
  });
  const [erros, setErros] = useState({});

  function handleChange(campo, valor) {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setErros(prev => ({ ...prev, [campo]: '' }));
    setErroGeral('');
  }

  function validarEtapa() {
    const novosErros = {};
    if (etapa === 0) {
      if (!form.nome.trim())     novosErros.nome     = 'Nome obrigatório';
      if (!form.email.trim())    novosErros.email    = 'E-mail obrigatório';
      if (!form.telefone.trim()) novosErros.telefone = 'Telefone obrigatório';
      if (form.senha.length < 6) novosErros.senha    = 'Mínimo 6 caracteres';
      if (form.senha !== form.confirmarSenha) novosErros.confirmarSenha = 'Senhas não conferem';
    }
    if (etapa === 1) {
      if (!form.cnpj.trim())        novosErros.cnpj        = 'CNPJ/CPF obrigatório';
      if (!form.razaoSocial.trim()) novosErros.razaoSocial = 'Razão social obrigatória';
    }
    if (etapa === 2) {
      if (!form.cep.trim())      novosErros.cep      = 'CEP obrigatório';
      if (!form.endereco.trim()) novosErros.endereco = 'Endereço obrigatório';
      if (!form.cidade.trim())   novosErros.cidade   = 'Cidade obrigatória';
      if (!form.estado.trim())   novosErros.estado   = 'Estado obrigatório';
    }
    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  }

  async function handleProximo() {
    if (!validarEtapa()) return;

    if (etapa < 2) {
      setEtapa(e => e + 1);
      return;
    }

    // Etapa final — salva no Firebase
    setSalvando(true);
    setErroGeral('');
    try {
      await cadastrarCliente({
        nome:  form.nome,
        email: form.email,
        senha: form.senha,
        telefone: form.telefone,
        cnpj: form.cnpj,
        endereco: {
          razaoSocial: form.razaoSocial,
          cep:     form.cep,
          rua:     form.endereco,
          numero:  form.numero,
          cidade:  form.cidade,
          estado:  form.estado,
        },
        // Vincula ao vendedor se veio pelo link
        vendedorId: vendedorLink?.uid || null,
      });
      setConcluido(true);
    } catch (e) {
      const msgs = {
        'auth/email-already-in-use': 'Este e-mail já está cadastrado.',
        'auth/invalid-email':        'E-mail inválido.',
        'auth/weak-password':        'Senha muito fraca.',
      };
      setErroGeral(msgs[e.code] || 'Erro ao criar conta. Tente novamente.');
    }
    setSalvando(false);
  }

  function handleEntrar() {
    onLogin('cliente');
  }

  const inputStyle = (campo) => ({
    width: '100%',
    background: erros[campo] ? '#fff5f5' : '#f8f8f7',
    border: `1px solid ${erros[campo] ? '#fca5a5' : '#e0e0dd'}`,
    borderRadius: 8,
    padding: '9px 12px',
    fontSize: 13,
    outline: 'none',
    boxSizing: 'border-box',
    color: '#1a1a1a',
    fontFamily: 'inherit',
  });

  const labelStyle = {
    fontSize: 11,
    fontWeight: 500,
    color: '#666',
    display: 'block',
    marginBottom: 4,
  };

  // ── Tela de boas-vindas ──
  if (concluido) {
    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: AZUL }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px 24px', gap: 16 }}>
          <div style={{ width: 72, height: 72, borderRadius: '50%', background: VERDE, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36 }}>
            ✓
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: '#fff', marginBottom: 8 }}>
              Bem-vindo, {form.nome.split(' ')[0]}!
            </div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
              Sua conta foi criada com sucesso.{'\n'}Você já pode fazer seus pedidos!
            </div>
          </div>

          {/* Vendedor vinculado */}
          {vendedorLink && (
            <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 12, padding: '12px 16px', width: '100%', display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: '50%', background: LARANJA, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
                {vendedorLink.nome?.split(' ').map(n => n[0]).slice(0, 2).join('')}
              </div>
              <div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Seu representante</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#fff' }}>{vendedorLink.nome}</div>
              </div>
              <div style={{ marginLeft: 'auto', background: 'rgba(255,255,255,0.15)', borderRadius: 6, padding: '4px 8px', fontSize: 10, color: '#fff', fontWeight: 500 }}>
                ✓ Vinculado
              </div>
            </div>
          )}
        </div>

        <div style={{ padding: '0 20px 24px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button onClick={handleEntrar}
            style={{ width: '100%', background: '#fff', border: 'none', borderRadius: 12, padding: 14, fontSize: 14, fontWeight: 700, color: AZUL, cursor: 'pointer' }}>
            Acessar o Catálogo →
          </button>
          <button onClick={() => onNavegar('home')}
            style={{ width: '100%', background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 12, padding: 12, fontSize: 13, fontWeight: 500, color: '#fff', cursor: 'pointer' }}>
            Ir para a Home
          </button>
        </div>
      </div>
    );
  }

  // ── Formulário ──
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: CINZA }}>

      {/* Header */}
      <div style={{ background: AZUL, padding: '14px 18px 20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
          <div onClick={() => etapa > 0 ? setEtapa(e => e - 1) : onNavegar('login')}
            style={{ color: 'rgba(255,255,255,0.7)', fontSize: 20, cursor: 'pointer' }}>←</div>
          <div style={{ color: '#fff', fontSize: 16, fontWeight: 600 }}>Criar Conta</div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
          {ETAPAS.map((label, i) => (
            <React.Fragment key={label}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                <div style={{ width: 28, height: 28, borderRadius: '50%', background: i <= etapa ? '#fff' : 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: i <= etapa ? AZUL : 'rgba(255,255,255,0.5)' }}>
                  {i < etapa ? '✓' : i + 1}
                </div>
                <span style={{ fontSize: 9, color: i <= etapa ? '#fff' : 'rgba(255,255,255,0.4)', fontWeight: i <= etapa ? 600 : 400 }}>{label}</span>
              </div>
              {i < ETAPAS.length - 1 && (
                <div style={{ flex: 1, height: 2, background: i < etapa ? '#fff' : 'rgba(255,255,255,0.2)', margin: '0 6px', marginBottom: 16 }} />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Vendedor vinculado */}
      {vendedorLink && (
        <div style={{ background: '#fff', borderBottom: '1px solid #e8e8e5', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#EAF3DE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: '#27500A', flexShrink: 0 }}>
            {vendedorLink.nome?.split(' ').map(n => n[0]).slice(0, 2).join('')}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 10, color: '#aaa' }}>Indicado por</div>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a' }}>{vendedorLink.nome}</div>
          </div>
          <div style={{ fontSize: 10, color: VERDE, fontWeight: 600 }}>✓ Vinculado</div>
        </div>
      )}

      {/* Formulário */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px 16px 0' }}>

        {/* ── ETAPA 0 — Conta ── */}
        {etapa === 0 && (
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '16px', marginBottom: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 14 }}>👤 Dados de Acesso</div>
            {[
              { campo: 'nome',           label: 'Nome completo *',        placeholder: 'Seu nome completo',   type: 'text'     },
              { campo: 'email',          label: 'E-mail *',               placeholder: 'seu@email.com.br',    type: 'email'    },
              { campo: 'telefone',       label: 'Telefone / WhatsApp *',  placeholder: '(11) 99999-0000',     type: 'tel'      },
              { campo: 'senha',          label: 'Senha *',                placeholder: 'Mínimo 6 caracteres', type: 'password' },
              { campo: 'confirmarSenha', label: 'Confirmar Senha *',      placeholder: 'Repita a senha',      type: 'password' },
            ].map(f => (
              <div key={f.campo} style={{ marginBottom: 12 }}>
                <label style={labelStyle}>{f.label}</label>
                <input value={form[f.campo]} onChange={e => handleChange(f.campo, e.target.value)} style={inputStyle(f.campo)} placeholder={f.placeholder} type={f.type} />
                {erros[f.campo] && <div style={{ fontSize: 10, color: '#e53e3e', marginTop: 3 }}>{erros[f.campo]}</div>}
              </div>
            ))}
          </div>
        )}

        {/* ── ETAPA 1 — Empresa ── */}
        {etapa === 1 && (
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '16px', marginBottom: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 14 }}>🏢 Dados da Empresa</div>
            {[
              { campo: 'cnpj',        label: 'CNPJ / CPF *',          placeholder: '00.000.000/0001-00'          },
              { campo: 'razaoSocial', label: 'Razão Social / Nome *', placeholder: 'Nome da empresa ou seu nome' },
            ].map(f => (
              <div key={f.campo} style={{ marginBottom: 12 }}>
                <label style={labelStyle}>{f.label}</label>
                <input value={form[f.campo]} onChange={e => handleChange(f.campo, e.target.value)} style={inputStyle(f.campo)} placeholder={f.placeholder} />
                {erros[f.campo] && <div style={{ fontSize: 10, color: '#e53e3e', marginTop: 3 }}>{erros[f.campo]}</div>}
              </div>
            ))}
          </div>
        )}

        {/* ── ETAPA 2 — Endereço ── */}
        {etapa === 2 && (
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '16px', marginBottom: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 14 }}>📍 Endereço de Entrega</div>
            {[
              { campo: 'cep',      label: 'CEP *',           placeholder: '00000-000'   },
              { campo: 'endereco', label: 'Rua / Avenida *', placeholder: 'Nome da rua' },
              { campo: 'numero',   label: 'Número',          placeholder: '123'         },
            ].map(f => (
              <div key={f.campo} style={{ marginBottom: 12 }}>
                <label style={labelStyle}>{f.label}</label>
                <input value={form[f.campo]} onChange={e => handleChange(f.campo, e.target.value)} style={inputStyle(f.campo)} placeholder={f.placeholder} />
                {erros[f.campo] && <div style={{ fontSize: 10, color: '#e53e3e', marginTop: 3 }}>{erros[f.campo]}</div>}
              </div>
            ))}
            <div style={{ display: 'flex', gap: 10 }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Cidade *</label>
                <input value={form.cidade} onChange={e => handleChange('cidade', e.target.value)} style={inputStyle('cidade')} placeholder="São Paulo" />
                {erros.cidade && <div style={{ fontSize: 10, color: '#e53e3e', marginTop: 3 }}>{erros.cidade}</div>}
              </div>
              <div style={{ width: 64 }}>
                <label style={labelStyle}>Estado *</label>
                <input value={form.estado} onChange={e => handleChange('estado', e.target.value)} style={inputStyle('estado')} placeholder="SP" maxLength={2} />
                {erros.estado && <div style={{ fontSize: 10, color: '#e53e3e', marginTop: 3 }}>{erros.estado}</div>}
              </div>
            </div>
          </div>
        )}

        {erroGeral && (
          <div style={{ background: '#fff5f5', border: '1px solid #fca5a5', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#e53e3e', marginBottom: 12 }}>
            {erroGeral}
          </div>
        )}

        <div style={{ height: 12 }} />
      </div>

      {/* Botão avançar */}
      <div style={{ padding: '10px 16px 16px', background: '#fff', borderTop: '1px solid #e8e8e5' }}>
        <button onClick={handleProximo} disabled={salvando}
          style={{ width: '100%', background: salvando ? '#aaa' : AZUL, border: 'none', borderRadius: 12, padding: 14, fontSize: 14, fontWeight: 600, color: '#fff', cursor: salvando ? 'not-allowed' : 'pointer' }}>
          {salvando ? 'Criando conta...' : etapa < 2 ? `Próximo: ${ETAPAS[etapa + 1]} →` : '✓ Criar Minha Conta'}
        </button>
        {etapa === 0 && (
          <p style={{ textAlign: 'center', fontSize: 12, color: '#888', marginTop: 10, marginBottom: 0 }}>
            Já tem conta?{' '}
            <span onClick={() => onNavegar('login')} style={{ color: AZUL, fontWeight: 600, cursor: 'pointer' }}>
              Fazer login
            </span>
          </p>
        )}
      </div>

    </div>
  );
}

export default Cadastro;